import { render, staticRenderFns } from "./196.vue?vue&type=template&id=5a5e2b38&scoped=true&"
var script = {}
import style0 from "./196.vue?vue&type=style&index=0&id=5a5e2b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e2b38",
  null
  
)

export default component.exports